import React, { useEffect, useRef, useState } from "react";
import { getPayment, getStudentData } from "../Service/ApiFunction";
import displayRazorpay from "../Utils/paymentGateway";
import { toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";

const Payment = () => {
  let c = document.querySelectorAll(".icon_cancel");
  const AlltypeFee = [
    "monthlyAmount",
    "inventoryAmount",
    "admissionfeetoBePaid",
    "TransportationAmount",
  ];
  const [note, setNote] = useState("");
  const [numberMonth, setMonthNumber] = useState(1);
  const [inventoryAmount, setInventoryAmount] = useState("");
  const [monthlyAmount, setMonthlyAmount] = useState(0);
  const [TransportationAmount, setTransportationAmount] = useState("");
  const [feeType, setFeeType] = useState([]);
  const [admissionFees, setAdmissionFees] = useState({});
  const [error, setError] = useState("");
  const [admissionfeetoBePaid, setadmissionfeetoBePaid] = useState("");
  const [loader, setLoader] = useState(false);
  const [PaymentData, setPaymentData] = useState({
    class: "",
    name: "",
    rollNumber: "",
    mobileno: "",
    amount: "",
    inventoryFee: "",
    transportationFee: "",
    admissionFee: "",
    school: "",
  });

  const getFeeStructure = async () => {
    const response = await getPayment();
    setAdmissionFees(
      response?.data?.find((e) => e?.class == PaymentData?.class)
    );
  };
  const addPaymentData = (name, value) => {
    setPaymentData((old) => {
      return { ...old, [name]: value };
    });
  };

  const getStudentDetails = async (roll) => {
    try {
      const response = await getStudentData(roll);
      const Sdata = response?.data;

      if (response?.data?.id) {
        setPaymentData({
          name: Sdata?.name,
          mobileno: Sdata?.contactNumber,
          class: Sdata?.class,
        });
        setFeeType([]);
        setNote("");
        setMonthlyAmount("");
        setTransportationAmount("");
        setError("");
        c?.forEach((e) => e?.click());
      } else {
        setError("Invalid Roll Number");
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    getFeeStructure();
    PaymentData?.rollNumber && getStudentDetails(PaymentData?.rollNumber);
  }, [PaymentData?.class, PaymentData?.rollNumber]);

  const submitAdmissionData = () => {
    setLoader(true);
    const amount =
      (+monthlyAmount || 0) +
      (+TransportationAmount || 0) +
      (+admissionfeetoBePaid || 0) +
      (+inventoryAmount || 0);
    if (amount == 0) {
      toast.error("Amount is Zero, Can not pay");
      return;
    }
    let valueObject = {
      monthlyAmount: monthlyAmount,
      TransportationAmount: TransportationAmount,
      admissionfeetoBePaid: admissionfeetoBePaid,
      inventoryAmount: inventoryAmount,
    };

    const fees = AlltypeFee.map((e) => {
      if (valueObject[e]) {
        return { [e]: valueObject[e] };
      }
    });
    const data = {
      data: {
        rollNumber: "7132023-9",
        name: "PaymentData?.name",
        phoneNumber: "PaymentData?.rollNumber",
        school: "SPHS School",
        class: "PaymentData?.class",
        amount: amount || 0,
        month: numberMonth || 1,
      },
      fee: [...fees.filter((e) => e !== undefined)],
    };

    try {
      displayRazorpay(data);
      setLoader(false);
    } catch (e) {
      toast.error(e.message);
      setLoader(false);
    }
  };

  const [options] = useState([
    "Admission",
    "Monthly",
    "Transportation",
    "Inventory",
  ]);

  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>Payment</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="career-bg">
        <div className="container">
          <div className="row">
            <div className="school-main-title">
              <div className="school-heading-subheading center-align text-center">
                <h2 className="school-title">Payment Form</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="sm-12">
              <div className="form-inner">
                <div className="row mb-3 g-3">
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Roll Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Roll Number"
                      name="rollNumber"
                      onChange={(e) =>
                        addPaymentData(e.target.name, e.target.value)
                      }
                    />
                    <small style={{ fontSize: "10px", color: "red" }}>
                      Enter Correct Roll No. To Fill The Details
                    </small>
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Full Name</label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Will be auto filled"
                      name="name"
                      value={PaymentData?.name}
                    />
                  </div>

                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Mobile No</label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Will be auto filled"
                      name="mobileno"
                      value={PaymentData?.mobileno}
                    />
                  </div>

                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Class</label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      placeholder="Will be auto filled"
                      name="class"
                      value={PaymentData?.class}
                    />
                  </div>

                  {PaymentData.class && (
                    <div className="col-lg-4 md-6 multi">
                      <label className="mb-2">Fee Type</label>
                      <Multiselect
                        className="searchWrapper"
                        isObject={false}
                        options={options}
                        showCheckbox
                        onSelect={(e) => {
                          let c = e.slice();
                          setFeeType(c);
                          let totalVal = c?.includes("Monthly")
                            ? (numberMonth || 1) *
                              (admissionFees?.monthlyFee || 0)
                            : 0;
                          setMonthlyAmount(totalVal);
                          let totalTransportFee = c?.includes("Transportation")
                            ? (note || 0) * (numberMonth || 1)
                            : 0;

                          setTransportationAmount(totalTransportFee);
                          let admissionFees1 = c?.includes("Admission")
                            ? admissionFees.admissionFee
                            : 0;

                          setadmissionfeetoBePaid(admissionFees1);
                        }}
                        onRemove={(e) => {
                          let c = e.slice();
                          setFeeType(c);

                          let totalMonth = c?.includes("Monthly")
                            ? numberMonth
                            : 1;
                          setMonthNumber(totalMonth);
                          let totalVal = c?.includes("Monthly")
                            ? (numberMonth || 1) *
                              (admissionFees?.monthlyFee || 0)
                            : 0;
                          setMonthlyAmount(totalVal);
                          let totalTransportFee = c?.includes("Transportation")
                            ? (note || 0) * (numberMonth || 1)
                            : 0;

                          setTransportationAmount(totalTransportFee);
                          if (!c?.includes("Admission")) {
                            setadmissionfeetoBePaid(0);
                          }
                          if (!c?.includes("Monthly")) {
                            setNote("");
                            setMonthlyAmount(0);
                            setTransportationAmount(0);
                            setMonthNumber("1");
                          }
                          if (!c?.includes("Transportation")) {
                            setNote("");
                            setTransportationAmount(0);
                          }
                        }}
                      />
                    </div>
                  )}
                  {feeType.includes("Monthly") && (
                    <>
                      <div className="col-lg-4 md-6">
                        <label className="mb-2">Select Number Of Months</label>
                        <select
                          className="select form-control"
                          onChange={(e) => {
                            setMonthNumber(e.target.value);
                            setMonthlyAmount(
                              e?.target?.value *
                                (admissionFees?.monthlyFee || 0)
                            );
                            feeType?.includes("Transportation") &&
                              setTransportationAmount(
                                e?.target?.value * (note || 0)
                              );
                          }}
                        >
                          <option selected value="1">
                            1
                          </option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                        </select>
                      </div>
                      {feeType.includes("Monthly") && PaymentData?.class && (
                        <div className="col-lg-4 md-6">
                          <label className="mb-2">Monthly Fee</label>
                          <input
                            disabled
                            type="number"
                            className="form-control"
                            placeholder="Monthly Fee"
                            name="mobileno"
                            value={monthlyAmount}
                          />
                        </div>
                      )}
                    </>
                  )}
                  {feeType?.includes("Transportation") &&
                    feeType?.includes("Monthly") &&
                    PaymentData?.class && (
                      <>
                        <div className="col-lg-4 md-6">
                          <label className="mb-2">
                            Transportation Fees Amount In Cash
                          </label>
                          <select
                            className="select form-control"
                            onChange={(e) => {
                              setNote(e.target.value);
                              let Month = numberMonth;
                              let totalValue = feeType?.includes(
                                "Transportation"
                              )
                                ? +e.target.value * (Month || 1)
                                : 0;
                              setTransportationAmount(totalValue);
                            }}
                          >
                            <option value="" selected>
                              Select..
                            </option>
                            <option value="500">Rs 500</option>
                            <option value="1000">Rs 1000</option>
                          </select>
                        </div>
                        <div className="col-lg-4 md-6">
                          <label className="mb-2">Transportation Fees</label>
                          <input
                            type="number"
                            className=" form-control"
                            disabled
                            value={TransportationAmount}
                          />
                        </div>
                      </>
                    )}
                  {feeType?.includes("Admission") && PaymentData?.class && (
                    <div className="col-lg-4 md-6">
                      <label className="mb-2">Admission fee</label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Amount"
                        name="admissionfee"
                        value={admissionFees?.admissionFee || 0}
                      />
                    </div>
                  )}
                  {feeType?.includes("Inventory") && (
                    <div className="col-lg-4 md-6">
                      <label className="mb-2">Inventory fee</label>
                      <input
                        type="number"
                        value={inventoryAmount}
                        onWheel={(e) => e.target.blur}
                        className="form-control"
                        placeholder="Enter Your Amount"
                        name="inventoryfee"
                        onChange={(e) => setInventoryAmount(e.target.value)}
                      />
                    </div>
                  )}
                  {(note || admissionFees?.admissionFee || inventoryAmount) && (
                    <div className="col-lg-4 md-6">
                      <label className="mb-2">Amount To Be Paid</label>
                      <input
                        disabled
                        type="text"
                        style={{ color: "red" }}
                        className="form-control"
                        placeholder="Enter Your Amount"
                        name="amount"
                        value={
                          (+monthlyAmount || 0) +
                          (+TransportationAmount || 0) +
                          (+admissionfeetoBePaid || 0) +
                          (+inventoryAmount || 0)
                        }
                      />
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="form-group col-md-12 text-center mt-4">
                    <button
                      className="theme-btn btn-style-one text-center"
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        if (error) {
                          toast.error(error);
                          return;
                        }
                        submitAdmissionData();
                      }}
                    >
                      <span>{loader ? "Wait..." : "Pay"}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
